import React, { CSSProperties } from "react";
import { omit, pick } from "../../libs/utils/object";

type propsType = React.HTMLAttributes<HTMLDivElement> &
    Pick<CSSProperties, "height" | "width"> & {
        children?: React.ReactNode;
        style?: CSSProperties;
    };

export const SizedBox: React.FC<propsType> = (props: propsType) => {
    const style: CSSProperties = {
        ...pick(props, ["height", "width"]),
        ...props.style,
    };
    const rest = omit(props, ["height", "width", "style"]);
    return (
        <div data-testid="SizedBox" {...rest} style={style}>
            {props.children}
        </div>
    );
};
